module.exports = __webpack_public_path__ + "img/PayPal_logo.2da7e883.svg";